import { render } from "./widget-history-skeleton.vue?vue&type=template&id=008a9454&scoped=true"
import script from "./widget-history-skeleton.vue?vue&type=script&lang=js"
export * from "./widget-history-skeleton.vue?vue&type=script&lang=js"

import "./widget-history-skeleton.vue?vue&type=style&index=0&id=008a9454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008a9454"]])

export default __exports__